<script>
import { saveAs } from "file-saver/FileSaver";
import { toArrayBuffer, formatDate } from "src/utils";
import { mapActions, mapMutations, mapState } from "vuex";
import {
  required,
  requiredUnless,
  email,
  minLength,
  maxLength,
  numeric,
  sameAs
} from "vuelidate/lib/validators";
import { hasOne, isDate } from "src/utils/validators";
import UserDetails from "./UserDetails";
import UserAddresses from "./UserAddresses";
import UserSecurity from "./UserSecurity";
import UserWizardRoles from "./UserWizardRoles";
import UserRecruiterFormDetails from "./UserDetailsRecruiterForm";
import UserAffiliateFormDetails from "./UserDetailsAffiliateForm";
import UserInstructorFormDetails from "./UserDetailsInstructorForm";
import UserDocuments from "./UserDocuments";
import UserNotes from "../User/UserNotes";
import UserWizardFinish from "./UserWizardFinish";

export default {
  name: "UserWizardModal",
  components: {
    UserDetails,
    UserAddresses,
    UserSecurity,
    UserWizardRoles,
    UserRecruiterFormDetails,
    UserAffiliateFormDetails,
    UserInstructorFormDetails,
    UserDocuments,
    UserNotes,
    UserWizardFinish
  },
  async mounted() {
    this.clearAllForms();
    this.$store.dispatch("users/fetchAffiliates");
    this.$store.dispatch("users/fetchRecruiters");
    this.$store.dispatch("users/fetchManagers");
    this.$store.dispatch("users/fetchAdministrators");
    this.$store.dispatch("courses/fetchAll");
    this.$store.commit("users/setSameAsBilling", { status: true })
  },
  data() {
    return {
      currentStep: 1,
      multipleSelect: [],
      disable: false,
      submitting: false
    };
  },
  validations() {
    let vm = this
    return {
      userForm: {
        USER_FIRST_NAME: { required },
        USER_LAST_NAME: { required },
        USER_EMAIL: { required, email },
        USER_DOB: vm.instructorForm.ACTIVE_IND
          ? { required, isDate }
          : { isDate },
        // USER_SSN_A: this.instructorForm.ACTIVE_IND
        //   ? { required, minLength: minLength(6), maxLength: maxLength(6) }
        //   : { minLength: minLength(6), maxLength: maxLength(6) },
        // USER_SSN_B: this.instructorForm.ACTIVE_IND
        //   ? { required, minLength: minLength(4), maxLength: maxLength(4) }
        //   : { minLength: minLength(4), maxLength: maxLength(4) },
        USER_PHONE:
          vm.affiliateForm.ACTIVE_IND ||
          vm.recruiterForm.ACTIVE_IND ||
          vm.instructorForm.ACTIVE_IND
            ? { required }
            : { required: false }
      },
      billingAddressForm: {
        ADDRESS_1:
          vm.affiliateForm.ACTIVE_IND ||
          vm.recruiterForm.ACTIVE_IND ||
          vm.instructorForm.ACTIVE_IND
            ? { required }
            : { required: false },
        LK_STATE_ID:
          vm.affiliateForm.ACTIVE_IND ||
          vm.recruiterForm.ACTIVE_IND ||
          vm.instructorForm.ACTIVE_IND
            ? { required }
            : { required: false },
        ZIP_CODE:
          vm.affiliateForm.ACTIVE_IND ||
          vm.recruiterForm.ACTIVE_IND ||
          vm.instructorForm.ACTIVE_IND
            ? { required, minLength: minLength(5), maxLength: maxLength(5) }
            : {
                required: false,
                minLength: minLength(5),
                maxLength: maxLength(5)
              },
        CITY:
          vm.affiliateForm.ACTIVE_IND ||
          vm.recruiterForm.ACTIVE_IND ||
          vm.instructorForm.ACTIVE_IND
            ? { required }
            : { required: false },
        COUNTY:
          (vm.affiliateForm.ACTIVE_IND ||
          vm.recruiterForm.ACTIVE_IND)
            ? { required }
            : { required: false }
      },
      shippingAddressForm: {
        ADDRESS_1:
          !vm.sameAsBilling &&
          (vm.affiliateForm.ACTIVE_IND ||
            vm.recruiterForm.ACTIVE_IND ||
            vm.instructorForm.ACTIVE_IND)
            ? { required }
            : { required: false },
        LK_STATE_ID:
          !vm.sameAsBilling &&
          (vm.affiliateForm.ACTIVE_IND ||
            vm.recruiterForm.ACTIVE_IND ||
            vm.instructorForm.ACTIVE_IND)
            ? { required }
            : { required: false },
        ZIP_CODE:
          !vm.sameAsBilling &&
          (vm.affiliateForm.ACTIVE_IND ||
            vm.recruiterForm.ACTIVE_IND ||
            vm.instructorForm.ACTIVE_IND)
            ? { required, minLength: minLength(5), maxLength: maxLength(5) }
            : { required: false },
        CITY:
          !vm.sameAsBilling &&
          (vm.affiliateForm.ACTIVE_IND ||
            vm.recruiterForm.ACTIVE_IND ||
            vm.instructorForm.ACTIVE_IND)
            ? { required }
            : { required: false },
        COUNTY:
          !vm.sameAsBilling &&
          (vm.affiliateForm.ACTIVE_IND ||
            vm.recruiterForm.ACTIVE_IND)
            ? { required }
            : { required: false }
      },
      changePasswordForm: {
        password: {
          required,
          minLength: minLength(6),
          maxLength: maxLength(20)
        },
        confirmPassword: {
          required,
          minLength: minLength(6),
          maxLength: maxLength(20),
          sameAs: sameAs("password")
        }
      },
      instructorForm: {
        INSTRUCTOR_AFFILIATES: (vm.instructorForm.ACTIVE_IND && vm.$p(['ADMIN', 'MANAGER'], 'or'))
          ? { required, minLength: minLength(1) }
          : { required: false},
        INSTRUCTOR_CODE: vm.instructorForm.ACTIVE_IND && vm.$p(['ADMIN', 'MANAGER'], 'or')
          ? { required }
          : { required: false },
        DRIVERS_LICENSE: vm.instructorForm.ACTIVE_IND
          ? { required }
          : { required: false },
        ACTIVE_IND: { isTrue: (value) => value }
      },
      affiliateForm: {
        AFFILIATE_CODE: vm.affiliateForm.ACTIVE_IND && vm.$p(['ADMIN', 'MANAGER'],'or')
          ? { required }
          : { required: false },
        AFFILIATE_NAME: vm.affiliateForm.ACTIVE_IND
          ? { required }
          : { required: false },
        STUDENT_PROCESSING_FEE: vm.affiliateForm.ACTIVE_IND
          ? { required }
          : { required: false },
        RECRUITER_FEE: (vm.affiliateForm.ACTIVE_IND) ? { 
          validateInput () {
            var isFieldValid;
            if(vm.affiliateForm.RECRUITER_FEE) {
                isFieldValid = (parseFloat(parseFloat(vm.affiliateForm.RECRUITER_FEE).toFixed(2)) < parseFloat(parseFloat(vm.affiliateForm.STUDENT_PROCESSING_FEE).toFixed(2)))? true:false
            } else{
              isFieldValid = true;
            }
              return isFieldValid;
            }
        } : { required: false },
        FEDERAL_EMPLOYER_IDENTIFICATION_NUMBER: vm.affiliateForm.ACTIVE_IND
          ? { required: requiredUnless("SOCIAL_SECURITY_NUMBER") }
          : { required: false },
        ACTIVE_IND: { isTrue: (value) => value },
        COURSES: vm.affiliateForm.ACTIVE_IND ? { required, minLength: minLength(1) } : { required: false }
      },
      recruiterForm: {
        // MANAGER_ID: (this.recruiterForm.ACTIVE_IND)
        //   ? { required }
        //   : { required: false },
        RECRUITER_CODE: vm.recruiterForm.ACTIVE_IND
          ? { required }
          : { required: false },
        ACTIVE_IND: { isTrue: (value) => value }
      },
      managerForm: { 
        ACTIVE_IND: { isTrue: (value) => value }
      },
      administratorForm: { 
        ACTIVE_IND: { isTrue: (value) => value }
      }
    };
  },
  watch: {
    validation: {
      handler(newVal, oldVal) {
      },
      deep: true
    }
  },
  computed: {
    ...mapState("users", {
      open: state => state.userWizardModal.open,
      maximized: state => state.userWizardModal.maximized,
      userForm: state => state.userForm,
      billingAddressForm: state => state.billingAddressForm,
      shippingAddressForm: state => state.shippingAddressForm,
      sameAsBilling: state => state.shippingAddressForm.sameAsBilling,
      instructorForm: state => state.instructorForm,
      affiliateForm: state => state.affiliateForm,
      recruiterForm: state => state.recruiterForm,
      managerForm: state => state.managerForm,
      managerCourses: state => state.managerCourses,
      administratorForm: state => state.administratorForm
    }),
    ...mapState("auth",{
      changePasswordForm: s => s.changePasswordForm
    }),
    courseOptions() {
      return this.$store.getters["courses/courseOptions"];
    },
    validation() {
      return this.$v;
    },
    hideBack() {
      if (this.currentStep === "roles") return true;
      if (this.currentStep === "documents") return true;
      return false
    },
    nextStepLabel() {
      if (this.currentStep === "start") return "Start";
      if (this.currentStep === "finish") return "Finish";
      return "Continue";
    }
  },
  methods: {
    ...mapMutations(["closeModal"]),
    ...mapMutations("users", [
      "closeUserWizardModal",
      "setSelectedUser",
      "updateManagerCourses",
      "setInvalidUserRoles"
    ]),
    ...mapActions("users", [
      "create",
      "clearAllForms"
    ]),
    toggleMaximized() {
      this.maximized = !this.maximized;
    },
    nextStep() {
      let vm = this
      vm.submitting = true
      
      if (vm.currentStep === "roles"){
        if(
          vm.administratorForm.ACTIVE_IND ||
          vm.managerForm.ACTIVE_IND ||
          vm.recruiterForm.ACTIVE_IND ||
          vm.affiliateForm.ACTIVE_IND ||
          vm.instructorForm.ACTIVE_IND
        ){
          vm.setInvalidUserRoles(false)
          return vm.proceed()
        }
        else{
          vm.setInvalidUserRoles(true)
        }
      }
      else if (vm.currentStep === "addresses"){
        vm.validation.billingAddressForm.$touch() 
        vm.validation.shippingAddressForm.$touch()
        if( !(
          vm.validation.billingAddressForm.$invalid ||
          vm.validation.shippingAddressForm.$invalid
        ))
          return vm.proceed()
      }
      else if(vm.currentStep  === "changePasswordForm"){
        let isValid = vm.validateCurrentForm(false)
        return isValid ? vm.createUser() : vm.submitting = false
      }
      else if (vm.currentStep === "documents") return vm.proceed()     
      else if (vm.currentStep === "finish") return vm.proceed({finish: true})
      else{
        // Auto Touch the forms.
        return vm.validateCurrentForm()
      }
      vm.submitting = false
    },
    validateCurrentForm(proceed = true){
      let vm = this
      let validationObject = vm.validation[vm.currentStep]
      if(validationObject){
        validationObject.$touch()
        if(!validationObject.$invalid){
           if(proceed) vm.proceed()
           return true
        }
        else
          vm.submitting = false
          return false
      }
      else{
        vm.submitting = false
        console.error("Validation Object Not set for " + vm.currentStep)
        return false
      }
    },
    proceed(options){
      let vm = this,
          finish = options ? options.finish : false
      if(!finish){
        vm.$refs.userStepper.next()
        vm.submitting = false
      }
      else{
        vm.$root.$emit('refreshGrid:userListGrid')
        vm.closeAndClearModal()
      }
    },
    async createUser() {
      const vm = this;
      
        return vm.$q.dialog({
          title: "Confirm Create",
          message:
            "You can not edit previous information after continuing, Continue?",
          ok: true,
          cancel: true
        })
        .then(async () => {
          const { success, payload } = await this.$store.dispatch(
            "users/create"
          );

          if (success) {
            await this.$store.commit("users/setSelectedUser", {
              user: { USER_ID: payload.USER_ID }
            });
            await this.$store.dispatch("auth/submitChangePasswordForm", {
              USER_ID: payload.USER_ID
            });
            vm.proceed()
          }
        })
        .catch(()=>{
          vm.submitting = false
        })
        
    },
    closeAndClearModal() {
      this.closeUserWizardModal();
      this.clearAllForms();
      this.submitting = false
      this.setInvalidUserRoles(false)
    },
    openUploadModal() {
      this.$store.commit("documents/openUpload");
    }
  }
};
</script>

<template>
  <q-modal
    no-backdrop-dismiss
    no-esc-dismiss
    class="sl-modal"
    id="userWizardModal"
    :maximized="maximized"
    :value="open"
    :content-css="{width: '1270px', maxWidth: '100%'}"
    @hide="closeAndClearModal()"
  >
    <q-modal-layout>
      <q-toolbar slot="header">
        <q-toolbar-title>
          <q-icon name="fa fa-magic"/>New User Wizard
        </q-toolbar-title>
        <!--<q-icon @click.native="toggleMaximized()" size="20px" class="gt-sm" name="filter_none" />-->
        <q-icon @click.native="closeAndClearModal()" name="clear"/>
      </q-toolbar>
      <q-stepper
        ref="userStepper"
        v-model="currentStep"
        alternative-labels
        :no-header-navigation="hideBack">
        <form @submit.prevent="nextStep()">
          <q-step name="roles" title="Roles" order="0">
            <user-wizard-roles :validation="$v"/>
          </q-step>
          <q-step default name="userForm" title="Details" order="1" :class="{'active': currentStep == 'details'}">
            <user-details :validation="$v"/>
            <user-notes/>
          </q-step>
          <q-step name="addresses" title="Addresses" order="2">
            <user-addresses :validation="$v"/>
          </q-step>            
          <q-step
            name="managerForm"
            title="Manager"
            order="5"
            v-if="managerForm.ACTIVE_IND"
          ><div class="q-pa-xl">
            <h5><q-icon name="fa fa-users" color="primary" /> Manager Details</h5>
            <q-select
              multiple
              chips
              float-label="Manager Courses"
              class="q-mt-lg"
              :value="managerCourses"
              :options="courseOptions"
              @input="(val) => updateManagerCourses(val)"
            />
            </div>
          </q-step>
          <q-step name="recruiterForm" title="Recruiter" order="3" v-if="recruiterForm.ACTIVE_IND">
            <div class="relative">
              <user-recruiter-form-details :validation="validation"/>
            </div>
          </q-step>
          <q-step name="affiliateForm" title="Affiliate" order="4" v-if="affiliateForm.ACTIVE_IND">
            <user-affiliate-form-details :validation="validation"/>
          </q-step>
          <q-step name="instructorForm" title="Instructor" order="5" v-if="instructorForm.ACTIVE_IND">
            <user-instructor-form-details :validation="validation"/>
          </q-step>
          <q-step name="changePasswordForm" title="Security" order="6">
            <user-security :validation="validation"/>
          </q-step>
          <q-step name="documents" title="Documents" order="7">
            <user-documents />
          </q-step>
          <q-step name="finish" title="Finish" order="8">
            <user-wizard-finish />
          </q-step>
        </form>
      </q-stepper>
      <q-toolbar slot="footer">
        <q-toolbar-title></q-toolbar-title>
        <!-- <q-btn color="green" icon="fa fa-gear" label="Next" @click="nextStep()"/>&nbsp; -->
        <q-btn
          color="green"
          @click="openUploadModal()"
          label="Upload Documents"
          v-if="currentStep === 'documents'"
          style="margin-right:10px"
        />
        <q-stepper-navigation>
          <q-btn color="blue" @click="nextStep()" :disable="submitting" :loading="submitting" :label="nextStepLabel" />
          <q-btn
            color="secondary"
            flat
            @click="$refs.userStepper.previous()"
            label="Back"
            v-show="!hideBack"
          />
        </q-stepper-navigation>
        <!-- <q-btn color="green" icon="fa fa-gear" label="Run"/>&nbsp; -->
        <!-- <q-btn outline color="faded" @click.native="closeUserWizardModal()" label="Cancel" /> -->
      </q-toolbar>
    </q-modal-layout>
  </q-modal>
</template>

<style lang="stylus">
#userWizardModal
  // .q-modal-layout-content
  //   overflow hidden !important

  .modal-content
              max-height 100%
      .sl-footer
          .q-btn
              margin-left 5px
      .q-stepper-tab
          .q-stepper-title
              transition font-size 0.2s ease-in-out
          &.step-active 
              .q-stepper-title
                  font-size 21px
      .q-stepper
          height 100% 
          flex-direction column
          flex-wrap nowrap
</style>